import classNames from 'classnames';
import React from 'react';
import { Wrapper } from './styled';
import styles from './styles.module.scss';
import { TooltipPosition } from './types';

const Tooltip = ({
  top,
  left,
  content,
  width,
  height,
  className,
  position = TooltipPosition.BOTTOM,
  color = '#0F006C'
}) => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: width,
      height: height,
      top: top,
      left: left,
      position: 'absolute'
    },
    className: classNames(styles.tooltip, className)
  }, /*#__PURE__*/React.createElement(Wrapper, {
    color: color,
    className: classNames(styles['tooltip-content'], styles[position])
  }, content));
};

export default Tooltip;